export interface PasswordConstraint {
  name: string;
  formKey: string;
}

export class Util {
  public static getPasswordConstraints(): PasswordConstraint[] {
    return [
      {
        name: 'password.rule1',
        formKey: 'invalidMinMaxPassword',
      },
      {
        name: 'password.rule2',
        formKey: 'invalidAtLeastOnePassword',
      },
      {
        name: 'password.rule3',
        formKey: 'invalidOneUpLower',
      },
      {
        name: 'password.rule4',
        formKey: 'invalidMaxTwoCharRepeat',
      },
      {
        name: 'password.rule5',
        formKey: 'invalidAcceptSymbols',
      },
      {
        name: 'password.rule6',
        formKey: 'invalidDisallowNameId',
      },
    ];
  }
  public static getAuth0PasswordConstraints(): PasswordConstraint[] {
    return [
      {
        name: 'auth0Password.rule1',
        formKey: 'invalidMinMaxPassword',
      },
      {
        name: 'auth0Password.rule2',
        formKey: 'invalidOneLower',
      },
      {
        name: 'auth0Password.rule3',
        formKey: 'invalidOneUpper',
      },
      {
        name: 'auth0Password.rule4',
        formKey: 'invalidOneNumber',
      },
    ];
  }
}
